module.exports = __webpack_public_path__ + "img/Articles_cards.06a77d6e.webp";